/**
 * Gets the cache key associated with the given pubkey.
 * @param pubkey
 * @returns
 */
export const getCacheKeyOfPublicKey = (pubkey) => pubkey.toString();
//# sourceMappingURL=utils.js.map